import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MeaButton from "../../../components/MeaButton";
import MeaDataTable from "../../../components/MeaDataTable";
import { useAuthContext } from "../../../hooks/useAuthContext";
import membersAPI from "../../../services/members";
import schoolsAPI from "../../../services/schools";
import { ToFormatedDateForEvents } from "../../../utils/dates";
import { replaceMailPreviewCidImages } from "../../../utils/mailPreview";

const SchoolMailsListComponent = ({ schoolId }) => {
  const { currentMembership } = useAuthContext();
  const navigate = useNavigate();
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  const [schoolAvatar, setSchoolAvatar] = useState("");
  const [mailBody, setMailBody] = useState("");
  const [previewDialogVisible, setPreviewDialogVisible] = useState(false);
  const [filters, setFilters] = useState({
    to: { value: "", matchMode: "contains" },
    subject: { value: "", matchMode: "contains" },
    status: { value: "", matchMode: "equals" },
  });
  const previewBody = replaceMailPreviewCidImages(mailBody, schoolAvatar);
  const statusOptions = [
    { label: "Tous", value: "" },
    { label: "Envoyé", value: "SENT" },
    { label: "Échoué", value: "FAILED" },
    { label: "Annulé", value: "CANCELLED" },
    { label: "Brouillon", value: "DRAFT" },
    { label: "En attente", value: "PENDING" },
    { label: "Soumis", value: "SUBMITTED" },
  ];

  const queryList = schoolsAPI.GetMails(
    schoolId,
    "",
    page,
    pageSize,
    filters?.to?.value || "",
    filters?.subject?.value || "",
    filters?.status?.value || ""
  );

  useEffect(() => {
    if (!schoolId) {
      setSchoolAvatar("");
      return;
    }
    schoolsAPI.GetOneSchool(schoolId).then((data) => {
      setSchoolAvatar(data?.data?.avatar || "");
    });
  }, [schoolId]);

  const showProfile = (e, item) => {
    e.preventDefault();
    membersAPI.GetMemberByEmail(schoolId, item?.to).then((data) => {
      if (data?.data?.length > 0) {
        navigate(`/school/${schoolId}/admin/members/${data?.data[0]?.id}`);
      }
    });
  };

  return (
    <>
      <Dialog
        visible={previewDialogVisible}
        onHide={() => setPreviewDialogVisible(false)}
        maximizable
        modal
        header="Aperçu de l'email"
        footer={<Button label="Fermer" icon="pi pi-times" onClick={() => setPreviewDialogVisible(false)} />}
        contentStyle={{ backgroundColor: "var(--mea-background-color)" }}
      >
        <div className="flex flex-column p-3 mt-3 h-full" style={{ backgroundColor: "white" }}>
          <div className="flex-grow-1">
            {!currentMembership?.is_owner && (
              <div dangerouslySetInnerHTML={{ __html: previewBody.replace(/<a\s+href=["'][^"']*["'][^>]*>/gi, '<a href="#" onclick="return false;">') }}></div>
            )}
            {currentMembership?.is_owner && (
              <div dangerouslySetInnerHTML={{ __html: previewBody }}></div>
            )}
          </div>
        </div>
      </Dialog>
      <MeaDataTable
        query={queryList}
        serviceAPI={schoolsAPI}
        names={{ pagination: "email", singular: "email", plural: "emails" }}
        showDeleteButton={false}
        setPage={setPage}
        setPageSize={setPageSize}
        filters={filters}
        onFilterCallback={(event) => {
          setFilters(event.filters);
          setPage(1);
        }}
        customFilterState={{ to: filters?.to?.value || "", subject: filters?.subject?.value || "", status: filters?.status?.value || "" }}
      >
        <Column
          field="to"
          header="Adresse e-mail"
          filter
          filterMatchMode="contains"
          filterPlaceholder="Rechercher un email"
          showFilterMenu={false}
          style={{ minWidth: "220px" }}
        />
        <Column
          field="subject"
          header="Objet"
          filter
          filterMatchMode="contains"
          filterPlaceholder="Rechercher un objet"
          showFilterMenu={false}
          style={{ minWidth: "220px" }}
        />
        <Column
          field="status"
          header="Statut"
          filter
          filterMatchMode="equals"
          showFilterMenu={false}
          filterElement={(options) => (
            <Dropdown
              value={options.value ?? ""}
              options={statusOptions}
              onChange={(e) => options.filterApplyCallback(e.value)}
              placeholder="Tous"
              className="w-full"
            />
          )}
          body={(item) => (
            <span>
              {(() => {
                switch (item.status) {
                  case "SENT":
                    return <><i className="pi pi-check-circle" style={{ color: "green" }}></i> Envoyé</>;
                  case "FAILED":
                    return <><i className="pi pi-times-circle" style={{ color: "red" }}></i> Échoué</>;
                  case "CANCELLED":
                    return <><i className="pi pi-times-circle" style={{ color: "red" }}></i> Annulé</>;
                  case "DRAFT":
                    return <><i className="pi pi-pencil" style={{ color: "blue" }}></i> Brouillon</>;
                  case "PENDING":
                    return <><i className="pi pi-clock" style={{ color: "orange" }}></i> En attente</>;
                  case "SUBMITTED":
                    return <><i className="pi pi-send" style={{ color: "purple" }}></i> Envoyé</>;
                  default:
                    return <><i className="pi pi-question-circle" style={{ color: "gray" }}></i> Inconnu</>;
                }
              })()}
            </span>
          )}
        />
        <Column
          field="created_at"
          header="Date d'envoi"
          body={(item) => (
            <span>{item.created_at ? ToFormatedDateForEvents(new Date(item.created_at), false) : "-"}</span>
          )}
        />
        <Column
          field="last_reaction_at"
          header="Dernière réaction le"
          body={(item) => (
            <span>{item.last_reaction_at ? <><i className="pi pi-check-circle" style={{ color: "green" }}></i> {ToFormatedDateForEvents(new Date(item.last_reaction_at), false)}</> : "-"}</span>
          )}
        />
        <Column
          field="preview"
          header="Aperçu"
          body={(item) => (
            <MeaButton
              icon="pi pi-eye"
              rounded
              text
              style={{ padding: "0", height: "1.5rem" }}
              onClick={() => {
                setMailBody(item.body);
                setPreviewDialogVisible(true);
              }}
            />
          )}
        />
        <Column
          field="member"
          header="Profil"
          body={(item) => (
            <MeaButton
              icon="pi pi-user"
              rounded
              text
              style={{ padding: "0", height: "1.5rem" }}
              onClick={(e) => showProfile(e, item)}
            />
          )}
        />
      </MeaDataTable>
    </>
  );
};

export default SchoolMailsListComponent;
